import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useModalBulk } from './useModalBulk';
import { UpgradeLink } from '../UpgradeLink';
import { jsx as _jsx } from "react/jsx-runtime";
const AdminContent = ({
  canUpgrade
}) => {
  if (canUpgrade) {
    return /*#__PURE__*/_jsx(UpgradeLink, {
      upgradeSource: "batch-enrichment",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkModal.adminLink"
      })
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkModal.adminContact"
    });
  }
};
export const CreditUpgradeTooltip = () => {
  const {
    canUpgrade
  } = useModalBulk();
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "bulkModal.locked",
    options: {
      adminContent: /*#__PURE__*/_jsx(AdminContent, {
        canUpgrade: canUpgrade
      })
    }
  });
};